import React from 'react';

export const AppContext = React.createContext({
    languageId: 'en-US',
    onLanguageChange: (e:any) => {},
});

AppContext.displayName = 'AppContext';